// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { UserService } from '@daml.js/utility-credential-app-v0/lib/Utility/Credential/App/V0/Service/User';
import { ERR_CAN_CRED_OFF, SUC_CAN_CRED_OFF } from '../../../../utils/strings';

export const useCancelCredentialOffer = () => {
  const { submit } = useExerciseSubmission(
    UserService.UserService_CancelCredentialOffer,
    SUC_CAN_CRED_OFF,
    ERR_CAN_CRED_OFF,
  );

  return submit;
};
